/* eslint-disable */

/**
 * 
 * 
 * This component is auto-generated, please don't touch it!
 * 
 * 
 */

import * as React from "react";

function La(props) {
  return <svg width="1em" height="1em" viewBox="0 0 512 336" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none"><path d="M512.001 70.897H0V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v61.794zm-8.829 264.827H8.828A8.829 8.829 0 0 1 0 326.896v-61.793h512v61.793a8.828 8.828 0 0 1-8.828 8.828z" fill="#FF4B55" /><path fill="#41479B" d="M0 70.897h512v194.207H0z" /><circle fill="#F5F5F5" cx={256} cy={168} r={70.621} /></g></svg>;
}

export default La;